import { watch, watchEffect } from '@vue/composition-api'
import { TOKEN_STORAGE_KEY, IS_SHARE_LINK_KEY, VERIFIER_STORAGE_KEY} from './utils/constants'
import { useLogin } from './composables'
import { urlsafebtoa, abtobs, bstoab, parseJSON } from './utils'

const { loggedIn, loginState, availableIssues, userInfo, hasAccess, initAuth, login, logout } = useLogin()

/**
 * Watch the various values and fire off dom events and add classes.
 */
watchEffect(() => {
  document.body.dataset.loggedIn = loggedIn.value
  document.body.dataset.loggedOut = !loggedIn.value
  document.body.dataset.hasAccess = hasAccess.value //|| meterAccess.value
  document.body.dataset.unknownAccess = hasAccess.value === null// && !meterAccess.value
})

watchEffect(_ => {
  if(!loginState.value) return // stop null being passed (if needed we can default it to inactive)
  window.dataLayer = window.dataLayer || []
  dataLayer.push({'pugpigAuthStatus': loginState.value })
  dataLayer.push({event: 'auth_status_updated'})
})

watch(_ => userInfo.value, (newValue, oldValue) => {
  // If oldValue is set that means it isn't the first run, remove this line or use watchEffect for constant checking..
  if(oldValue) return 
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({'pugpig_user': newValue})
  window.dataLayer.push({ event: 'pugpig_user_updated' })
  const event = new CustomEvent("PugpigUserLoaded", { detail: { user: newValue }})
  window.dispatchEvent(event)
})

/**
 * Debug to show that things are changin' and events work.
 * This can be removed once we're happy
 */

watchEffect(_ => {
  window._pp_ = window._pp_ || {}
  window._pp_.auth = {
    loggedIn: loggedIn.value, 
    isAuthorised: hasAccess.value,
    userInfo: userInfo.value,
  }
})

/**
 * Mount Apps if they exist and event listener.
 * Dynamically request js file if page exists.
 */

window.addEventListener('PugpigUserLoaded', _ => {
  console.log('PugpigUserLoaded::', window.dataLayer || [])
})

window.addEventListener('DOMContentLoaded', async () => {
  var url = window.location.href
  var hostname = window.location.hostname
  if (url.startsWith('https://' + hostname + '/?token=')) {
    var urlObj = new URL(url);
    var token = urlObj.searchParams.get('token');
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
    localStorage.setItem(IS_SHARE_LINK_KEY, true)
  } else if (url.startsWith('https://' + hostname + '/MyLoginCallback')) {
    var urlObj = new URL(url);
    var myLoginCallbackCode = urlObj.searchParams.get('code')
    if (myLoginCallbackCode) {
      const code = crypto.getRandomValues(new Uint8Array(32))
      const code_verifier = urlsafebtoa(await abtobs(code))
      const bstoabCodeVerifier = await bstoab(code_verifier)
      const hash = bstoabCodeVerifier;
      const code_challenge = urlsafebtoa(await abtobs(hash))
      localStorage.setItem(VERIFIER_STORAGE_KEY, code_verifier)
      const {sign_in_url} = window.PASSPORT_CONFIG
      let newMyLoginCallbackUrl = new URL(`/MyLoginCallback?code=${myLoginCallbackCode}&app=30&referrerUrl=https://${hostname}/oidc?code_challenge=${code_challenge}`, sign_in_url);
      window.open(newMyLoginCallbackUrl, '_self')
    }
  }

  // Bind Event Listeners for Buttons
  const login_buttons = document.querySelectorAll('#pp-subs-login')
  const logout_buttons = document.querySelectorAll('#pp-subs-logout')
  login_buttons.forEach(button => button.addEventListener('click', login))
  logout_buttons.forEach(button => button.addEventListener('click', logout))
  // Initialise Auth
  initAuth()
})

/**
 * Set entitlements based on all issues.
 * Triggered by availableIssues changing and `PugpigDOMContentUpdated` being triggered.
 */
function setEntitlementDataAttributes() {
  const pendingSections = document.querySelectorAll('[data-entitlement]')
  const grantedSections =  document.querySelectorAll('[data-entitlement-granted]')

  // Remove entitlements
  grantedSections.forEach(section => section.removeAttribute('data-entitlement-granted'))

  // Resolve entitlements
  pendingSections.forEach(section => {
    const sectionEntitlements = section.getAttribute('data-entitlement')
    const entitlementsValue = parseJSON(sectionEntitlements)
    const entitlementsArray = typeof entitlementsValue === 'string' ? [entitlementsValue] : entitlementsValue

    if (entitlementsArray.length == 0) {
      section.setAttribute('data-entitlement-granted', true)
      return true
    }

    entitlementsArray.some(entitlement => {
      if(!availableIssues.value.includes(entitlement)) return false
      section.setAttribute('data-entitlement-granted', true)
      return true
    })
  })
}

watchEffect(() => setEntitlementDataAttributes())
window.addEventListener('PugpigDOMContentUpdated', () => setEntitlementDataAttributes())